(function () {
  const DOMAINS = ["fury", "calm", "mind", "body", "chaos", "order"];

  const Core = {
    DOMAINS: DOMAINS,

    cardById(id) {
      if (!Core._index) {
        Core._index = {};
        for (const c of window.CARD_DB) Core._index[c.id] = c;
      }
      return Core._index[id];
    },

    card(state, iid) {
      const o = state.objs[iid];
      if (!o) return null;
      if (o.copyCard) return Core.cardById(o.copyCard);
      if (o.copyToken) return o.copyToken;
      if (o.card) return Core.cardById(o.card);
      return o.token || null;
    },

    name(state, iid) {
      const c = Core.card(state, iid);
      return c ? c.name : "?";
    },

    cardId(state, iid) {
      const c = Core.card(state, iid);
      return (c && c.id) || null;
    },

    pipDomains(domains) {
      return domains && domains.length && domains[0] !== "colorless" ? domains : null;
    },

    isType(state, iid, type) {
      const c = Core.card(state, iid);
      return !!c && (c.types || []).indexOf(type) >= 0;
    },

    makeObj(state, def) {
      const iid = "o" + state.nextIid++;
      const o = Object.assign(
        {
          iid: iid,
          card: null,
          token: null,
          owner: 0,
          controller: 0,
          zone: "deck",
          loc: null,
          ready: true,
          damage: [],
          buffs: 0,
          stunned: false,
          empowered: false,
          hiddenInfo: null,
          attachedTo: null,
          attachments: [],
          grants: [],
          designation: null,
          enteredTurn: -1,
          flags: {},
        },
        def
      );
      state.objs[iid] = o;
      return o;
    },

    makeBattlefield(state, cardId, owner, controller) {
      const bf = Core.makeObj(state, {
        card: cardId, owner: owner, controller: controller === undefined ? null : controller,
        zone: "board", loc: null, ready: true,
      });
      bf.contestedBy = null;
      bf.scoredBy = [];
      bf.facedownIid = null;
      bf.stagedShowdown = false;
      bf.stagedCombat = false;
      return bf;
    },

    rebirth(state, iid) {
      const o = state.objs[iid];
      const n = Core.makeObj(state, {
        card: o.card,
        token: o.token,
        owner: o.owner,
        controller: o.owner,
        zone: o.zone,
        loc: null,
      });
      delete state.objs[iid];
      return n;
    },

    totalDamage(o) {
      let s = 0;
      for (const d of o.damage) s += d.amt;
      return s;
    },

    unitsAt(state, loc, filter) {
      const out = [];
      for (const iid in state.objs) {
        const o = state.objs[iid];
        if (o.zone !== "board" || o.attachedTo) continue;
        if (!Core.isType(state, iid, "unit")) continue;
        if (!Core.sameLoc(o.loc, loc)) continue;
        if (filter && !filter(o)) continue;
        out.push(iid);
      }
      return out;
    },

    effectSources(state, opts) {
      const o = opts || {};
      const srcs = Core.boardObjs(state);
      if (o.legends !== false) for (const pl of state.players) srcs.push(pl.legendIid);
      if (o.battlefields !== false) for (const bf of state.battlefields) if (srcs.indexOf(bf) < 0) srcs.push(bf);
      return srcs;
    },

    runesOf(state, p) {
      return Core.boardObjs(state, function (o, iid) {
        return o.controller === p && Core.isType(state, iid, "rune");
      });
    },

    ruleSources(state, key, opts) {
      const o = opts || {};
      const pool = o.legends ? Core.effectSources(state, { battlefields: false }) : Core.boardObjs(state);
      const out = [];
      for (const iid of pool) {
        const so = state.objs[iid];
        if (!so || so.attachedTo) continue;
        if (o.controller !== undefined && so.controller !== o.controller) continue;
        const sc = RB.Scripts.forCard(state, iid);
        if (!sc || !sc[key]) continue;
        out.push({ iid: iid, obj: so, script: sc, rule: sc[key] });
      }
      return out;
    },

    auraScopeActive(so, ss) {
      return !(ss.auraRestrictScope === "atBf" && !(so.loc && so.loc.t === "bf"));
    },

    boardObjs(state, filter) {
      const out = [];
      for (const iid in state.objs) {
        const o = state.objs[iid];
        if (o.zone !== "board") continue;
        if (filter && !filter(o, iid)) continue;
        out.push(iid);
      }
      return out;
    },

    sameLoc(a, b) {
      if (!a || !b) return false;
      if (a.t !== b.t) return false;
      if (a.t === "base") return a.p === b.p;
      return a.iid === b.iid;
    },

    locName(state, loc) {
      if (!loc) return "nowhere";
      if (loc.t === "base") return "P" + (loc.p + 1) + " base";
      return Core.name(state, loc.iid);
    },

    playersUnitsAtBf(state, bfIid) {
      const present = {};
      for (const iid of Core.unitsAt(state, { t: "bf", iid: bfIid })) {
        present[state.objs[iid].controller] = true;
      }
      return Object.keys(present).map(Number);
    },

    log(state, msg, meta) {
      const entry = { t: state.turn.num, msg: msg };
      if (meta) {
        if (meta.k) entry.k = meta.k;
        if (meta.p !== undefined && meta.p !== null) entry.p = meta.p;
        const refs = [];
        const seen = {};
        const add = function (iid, isTarget) {
          const ref = Core.logRef(state, iid);
          if (!ref || seen[ref.i]) return;
          if (isTarget) ref.g = 1;
          seen[ref.i] = 1;
          refs.push(ref);
        };
        for (const iid of meta.iids || []) add(iid, false);
        for (const iid of meta.tgt || []) add(iid, true);
        if (refs.length) entry.r = refs;
      }
      state.gameLog.push(entry);
    },

    logRef(state, iid) {
      if (typeof iid !== "string") return null;
      const o = state.objs[iid];
      if (!o) return null;
      const c = Core.card(state, iid);
      const ref = { i: iid, n: c ? c.name : "?", p: o.controller };
      if (c && c.id) ref.c = c.id;
      return ref;
    },

    itemTargets(item) {
      const out = [];
      const targets = (item && item.targets) || {};
      for (const bind in targets) {
        const picks = targets[bind];
        for (const t of Array.isArray(picks) ? picks : [picks]) {
          if (typeof t === "string" && out.indexOf(t) < 0) out.push(t);
        }
      }
      return out;
    },

    targetNames(state, iids) {
      return (iids || []).map(function (t) {
        if (t.indexOf("chain:") === 0) {
          const it = (state.chain || []).find(function (x) { return "chain:" + x.id === t; });
          return it ? it.label : "a chain item";
        }
        return Core.name(state, t);
      });
    },

    targetClause(state, iids) {
      const names = Core.targetNames(state, iids);
      return names.length ? ", targeting " + names.join(" and ") : "";
    },

    otherPlayer(p) {
      return 1 - p;
    },

    poolTotalPower(pool) {
      let s = pool.power.any || 0;
      for (const d of DOMAINS) s += pool.power[d] || 0;
      return s;
    },

    emptyPool() {
      return { energy: 0, power: { any: 0, fury: 0, calm: 0, mind: 0, body: 0, chaos: 0, order: 0 }, r: null };
    },

    emptyAllPools(state) {
      for (const p of state.players) p.pool = Core.emptyPool();
    },
  };

  window.RB = window.RB || {};
  window.RB.Core = Core;
})();
